// Feature-local DRF error router. Turns an axios error from a DRF
// PATCH/POST response into a flat { field: message } map the widget
// can distribute to per-Field `error` props. See
// migration/phase9-text-form-plan.md §4 for the design rationale.
//
// Output shape:
//   { [field]: "message", _form?: "message" }
// where _form holds detail / non_field_errors / fallback messages.
//
// Deliberately feature-local — duplicated by the next feature that
// needs the same shape until a third consumer establishes the
// pattern (per phase7-mutation-validation.md §10.2 "two is the bar").

export const messageFromError = (error) => {
  if (!error) return "Помилка з'єднання.";
  if (error.response && error.response.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    if (typeof data.detail === "string") return data.detail;
  }
  if (error.message && typeof error.message === "string") {
    return error.message;
  }
  return "Помилка з'єднання.";
};

const pickFirstString = (value) => {
  if (typeof value === "string") return value;
  if (Array.isArray(value) && value.length > 0) {
    return typeof value[0] === "string" ? value[0] : String(value[0]);
  }
  return undefined;
};

export const parseDrfFieldErrors = (error, editableFields) => {
  const data = error && error.response && error.response.data;

  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return { _form: messageFromError(error) };
  }

  const next = {};

  for (const field of editableFields) {
    const fieldMessage = pickFirstString(data[field]);
    if (fieldMessage) {
      next[field] = fieldMessage;
    }
  }

  const formMessage = pickFirstString(data.non_field_errors)
    || (typeof data.detail === "string" ? data.detail : undefined);
  if (formMessage) {
    next._form = formMessage;
  }

  if (Object.keys(next).length === 0) {
    next._form = messageFromError(error);
  }

  return next;
};
